/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Here mentioned users feature request structure
 */
const API = {
  GET_USER_LIST: {
    path: '/organizations/:organizationId/users?:query',
    method: 'GET',
  },
  GET_SELECTED_USER_LIST: {
    path: '/organizations/:organizationId/users?:query',
    method: 'GET',
  },
  GET_ROLES: {
    path: '/organizations/:organizationId/roles',
    method: 'GET',
  },
  GET_HOTELS: {
    path: '/organizations/:organizationId/users/:userId/hotels?:query',
    method: 'GET',
  },
  GET_ALL_HOTELS: {
    path: '/organizations/:organizationId/hotels?:query',
    method: 'GET',
  },
  POST_USERS: {
    path: '/organizations/:organizationId/users',
    method: 'POST',
  },
  POST_USERS_ADMIN: {
    path: '/organizations/:organizationId/users/admin',
    method: 'POST',
  },
  POST_USERS_GENERAL: {
    path: '/organizations/:organizationId/users/general',
    method: 'POST',
  },
  PATCH_USER: {
    path: '/organizations/:organizationId/users/:userId',
    method: 'PATCH',
  },
  PATCH_ROLE: {
    path: '/organizations/:organizationId/users/:userId/assign-roles',
    method: 'PATCH',
  },
  PATCH_HOTEL: {
    path: '/organizations/:organizationId/users/:userId/hotels',
    method: 'PATCH',
  },
  DELETE_USER: {
    path: '/organizations/:organizationId/users/:userId',
    method: 'DELETE',
  },
  INVITE_USER: {
    path: '/organizations/:organizationId/invites',
    method: 'POST',
  },
  GET_USER_INVITES: {
    path: '/organizations/:organizationId/invites?:query',
    method: 'GET',
  },
  POST_CHANGE_PASSWORD: {
    path: '/organizations/:organizationId/users/:userId/change-password',
    method: 'POST',
  },
  GET_ALL_HOTEL_GROUPS: {
    path: '/organizations/:organizationId/configurations/hotel-group?:query',
    method: 'GET',
  },
  GET_ASSIGNED_HOTEL_GROUPS: {
    path: '/organizations/:organizationId/users/:userId/configurations/assigned-hotel-groups',
    method: 'GET',
  },
  ASSIGN_HOTEL_GROUPS: {
    path: '/organizations/:organizationId/users/:userId/configurations/assigned-hotel-groups',
    method: 'POST',
  },
};
//
export default API;
